import React from "react";
import styled from "styled-components";
import { colors } from "../theme";
import { useWindowManager } from "../WindowManager";
import {
  AppScroll,
  AppEyebrow,
  AppLead,
  PillButton,
} from "./shared";

const Name = styled.span`
  font-size: 42px;
  font-weight: 700;
  color: ${colors.green};
  line-height: 1.05;
`;

const Cursor = styled.span`
  font-size: 38px;
  color: ${colors.purple};
  vertical-align: top;
  animation: blinker 1s linear infinite;
`;

const Tagline = styled.div`
  font-size: 22px;
  font-weight: 600;
  margin: 14px 0 18px;
  max-width: 52ch;
  line-height: 1.3;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
`;

const AboutApp = () => {
  const { openApp } = useWindowManager();

  return (
    <AppScroll>
      <AppEyebrow>Hey, I'm</AppEyebrow>
      <div>
        <Name>Harrison</Name>
        <Cursor> |</Cursor>
      </div>
      <Tagline>A full-stack developer based out of NYC.</Tagline>
      <AppLead>
        Building cool things and creative experiences that make people curious.
      </AppLead>
      <AppLead>
        Click/drag some stuff around, close/minimize/resize this window, check out the other apps... or don't - the choice is yours.
      </AppLead>
      <Actions>
        <PillButton $bg={colors.green} onClick={() => openApp("experience")}>
          See my experience
        </PillButton>
        <PillButton $bg={colors.peach} onClick={() => openApp("skills")}>
          View my tech stack
        </PillButton>
        <PillButton $bg={colors.sky} onClick={() => openApp("resume")}>
          Open my resume
        </PillButton>
      </Actions>
    </AppScroll>
  );
};

export default AboutApp;
